<template>
  <div class="menu" :class="{ 'collapse': isFlag }">
    <el-menu :default-active="activeMenu" mode="vertical" :unique-opened="true" router background-color="#262C36" text-color="#fff" active-text-color="#1F91F3" @select="selectMenu" :collapse="isCollapse">
      <!-- 一级菜单 -->
      <template v-for="menu1 in menus1">
        <el-submenu v-if="menu1.url === '/'" :index="menu1.id" :key="menu1.id">
          <template slot="title">
            <i v-if="menu1.icon !== ''" class="myIcon iconfont" :class="menu1.icon"></i>
            <span>{{ menu1.name }}</span>
          </template>
          <!-- 二级菜单 -->
          <template v-for="menu2 in menus2" v-if="menu1.id === menu2.pId">
            <el-menu-item v-if="menu2.url !== '/'" :index="menu2.url" :key="menu2.id">{{ menu2.name }}</el-menu-item>
            <el-submenu v-else :index="menu2.id" :key="menu2.id">
              <template slot="title">
                <span>{{ menu2.name }}</span>
              </template>
            </el-submenu>
          </template>
        </el-submenu>
        <el-menu-item v-else :index="menu1.url" :key="menu1.id">
          <i v-if="menu1.icon !== ''" class="myIcon iconfont" :class="menu1.icon"></i>
          <span slot="title">{{ menu1.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: ['isFlag'],
  data () {
    return {
      menus1: this.$store.state.menus.menu1,
      menus2: this.$store.state.menus.menu2,
      activeMenu: this.$store.state.menus.activeMenu
    }
  },
  methods: {
    selectMenu (index) {
      this.$store.dispatch('activeMenu', index)
    }
  },
  computed: {
    isCollapse () {
      return this.isFlag
    }
  },
  watch: {
    $route (to, from) {
      let routerChange = false
      for (let i = 0; i < this.menus1.length; i++) {
        if (this.menus1[i].url === to.path) {
          routerChange = true
          break
        }
      }
      for (let i = 0; i < this.menus2.length; i++) {
        if (this.menus2[i].url === to.path) {
          routerChange = true
          break
        }
      }
      if (routerChange) {
        this.selectMenu(to.path)
        this.activeMenu = to.path
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.menu
  padding 24px 0
  width 240px
  font-weight bold
  &.collapse
    width 64px
.el-menu
  border-bottom none !important
  border-right none !important
.el-submenu
  .el-submenu__icon-arrow
    color #fff
.el-submenu__title
  height 50px !important
  line-height 50px !important
  opacity .75
.myIcon
  margin-right 16px
  color #fff !important
.el-menu--inline
  .el-menu-item
    padding-left 56px !important
    background-color rgb(11, 12, 15) !important
.is-active
  .el-submenu__title
    color #fff !important
    background-color #1F91F3 !important
    border none !important
    opacity 1
  &.is-opened
    .el-submenu__title
      background-color rgb(38, 44, 54) !important
      &:focus, &:hover
        background-color #1F91F3 !important
.el-submenu__title:focus,
.el-submenu__title:hover
  background-color #1F91F3 !important
  opacity 1
.el-menu-item
  height 50px !important
  line-height 50px !important
  opacity .75
  &.is-active
    color #fff !important
    background-color #1F91F3 !important
    border none !important
    opacity 1
  &:hover
    background-color #1F91F3 !important
    opacity 1
.el-menu--popup
  .el-menu-item
    height 40px !important
    line-height 40px !important
    &.is-active
      color #1F91F3 !important
      background-color #262C36 !important
      border none !important
    &:hover
      color #1F91F3 !important
      background-color #262C36 !important
  .el-submenu__title:focus,
  .el-submenu__title:hover
    color #1F91F3 !important
    background-color #262C36 !important
    border none !important
    .el-submenu__icon-arrow
      color #1F91F3 !important
  .is-active
    .el-submenu__title
      color #1F91F3 !important
      background-color #262C36 !important
      border none !important
      .el-submenu__icon-arrow
        color #1F91F3 !important
</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue